import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

import { EntityConnectionTypeDetails, GetEntityConnectionTypesGQL } from 'generated/graphql';

export interface ConnectionMatchingOperatorDialogData {
  campaignId: string;
  entityConnectionTypeId: string;
  hasConnections: boolean;
  connectionMatchingRule?: string;
  entityConnectionTypes: EntityConnectionTypeDetails.Fragment[];
}

export interface ConnectionMatchingDialogCloseData {
  hasConnections: boolean;
  entityConnectionTypeId: string;
}

@Component({
  selector: 'app-connection-matching-operator',
  templateUrl: './connection-matching-operator.dialog.html',
  styleUrls: ['./connection-matching-operator.dialog.scss']
})

export class ConnectionMatchingOperatorDialog  {
  campaignId: string;
  entityConnectionTypeId: string;
  hasConnections = false;
  entityConnectionTypes: EntityConnectionTypeDetails.Fragment[] = [];
  static open(dialog: MatDialog, config: MatDialogConfig<ConnectionMatchingOperatorDialogData>) {
    return dialog.open<ConnectionMatchingOperatorDialog, ConnectionMatchingOperatorDialogData, ConnectionMatchingDialogCloseData>
      (ConnectionMatchingOperatorDialog, config);
  }


  get selectedEntityConnectionType() {
    return this.entityConnectionTypes.find(e => e.id === this.entityConnectionTypeId) || null;
  }

  constructor(
    public dialogRef: MatDialogRef<ConnectionMatchingOperatorDialog>,
    private _getEntityConnectionTypesGQL: GetEntityConnectionTypesGQL,
    @Inject(MAT_DIALOG_DATA) public data: ConnectionMatchingOperatorDialogData
  ) {
    this.campaignId = data.campaignId;
    this.entityConnectionTypes = data.entityConnectionTypes;
    this.entityConnectionTypeId = data.entityConnectionTypeId;
    this.hasConnections = data.hasConnections;
  }


  onDone() {
    this.close({
      hasConnections: this.hasConnections,
      entityConnectionTypeId: this.entityConnectionTypeId
    });
  }

  close(data: ConnectionMatchingDialogCloseData = null) {
    return this.dialogRef.close(data);
  }
}
